import Vue from 'vue';
import Router from 'vue-router';

import DefaultLayout from '@/layout/default.vue';
import GameView from '@/views/Game.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/game',
      name: 'App',
      component: DefaultLayout,
      children: [
        {
          path: 'game',
          name: 'Game',
          component: GameView
        }
      ]
    }
  ]
});
